import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PersonaProgramaSubPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PersonaProgramaSubPage",
            ss: ss,
            ajax: {
                "url": ss.indexPersonaProgramaSub(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Persona', name: 'p.Persona', title: 'Persona' },
                { data: 'NombreSubPrograma', name: 'pps.NombreSubPrograma', title: 'SubPrograma' },
                { data: 'Periodo', name: 'pps.Periodo', title: 'Periodo' },
                { data: 'Gestion', name: 'pps.Gestion', title: 'Gestión' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            personaprogramasubs: [],
            personaprogramasub: {},
            personas: [],
            persona:{},
            queryPersona: "",
            defensas:[],
            tipomiembros:[],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
       
        newPersonaProgramaSub() {
            this.personaprogramasub = {};
            this.$refs['frm-personaprogramasub'].show();
        },
        showPersonaProgramaSub(id) {
            this.isLoading=true;
            this.ss.showPersonaProgramaSub(id).then(
                (result) => {
                    let response = result.data;
                    this.personaprogramasub = response.data;
                    this.$refs['view-personaprogramasub'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPersonaProgramaSub() {
            this.$refs['frm-personaprogramasub'].show();
            this.$refs['view-personaprogramasub'].hide();
        },
        cancelPersonaProgramaSub() {
            if (this.personaprogramasub.id) {
                this.$refs['frm-personaprogramasub'].show();
            }
            this.$refs['frm-personaprogramasub'].hide();
        },
        savePersonaProgramaSub() {
            this.ss.storePersonaProgramaSub(this.personaprogramasub).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-personaprogramasub'].hide();
                    this.$refs['datatable-personaprogramasub'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePersonaProgramaSub() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPersonaProgramaSub(this.personaprogramasub)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['frm-personaprogramasub'].hide();
                                this.$refs['datatable-personaprogramasub'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-PersonaProgramaSub').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPersonaProgramaSub(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    watch: {
        queryPersona(q) {
            this.ss.select2Persona(q).then((res) => {
                console.log(res);
                if (res.data.success) {
                    this.personas = res.data.items;
                } else {
                    this.personas = [];
                }
            })
        }
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
           /*  this.getDefensas();
            this.getTipoMiembros(); */
        }
    }
};
